import React from 'react';

export interface OrderProps {}

const Order: React.FC<OrderProps> = () => {
  return null;
};

export default Order;
